import React, { Component } from 'react'
import Dialog from "./../../../../../components/dialog-base"
import './styles.scss'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'


interface IFlatsNumbersProps {
    onClose: () => void
    item: {
        id: string,
        img: string,
        name: string,
        price: number,
        size: string,
        type: number
    }
}

class FlatsNumbersPopUp extends React.Component<IFlatsNumbersProps & ReturnType<typeof storesToProps>> {
    public state = {
        startLeftFlat: 1,
        endLeftFlat: 2,
        startRigthFlat: 3,
        endRigthFlat: 4,
    }


    public minusStartLeftFlat = () => {
        if (this.state.startLeftFlat > 1) {
            this.setState({ startLeftFlat: this.state.startLeftFlat - 1 })
        }
    }
    public minusEndLeftFlat = () => {
        if (this.state.endLeftFlat > 1 && this.state.endLeftFlat > this.state.startLeftFlat) {
            this.setState({ endLeftFlat: this.state.endLeftFlat - 1 })
        }
    }

    public plusStartLeftFlat = () => {
        if (this.state.endLeftFlat > this.state.startLeftFlat) {
            this.setState({ startLeftFlat: this.state.startLeftFlat + 1 })
        } else {
            this.setState({ startLeftFlat: this.state.startLeftFlat + 1, endLeftFlat: this.state.startLeftFlat + 1 })
        }
    }
    public plusEndLeftFlat = () => {
        if (this.state.startRigthFlat - 1 > this.state.endLeftFlat) {
            this.setState({ endLeftFlat: this.state.endLeftFlat + 1 })
        }

    }

    public minusStartRigthFlat = () => {
        if (this.state.startRigthFlat > 1 && this.state.startRigthFlat > this.state.endLeftFlat + 1) {
            this.setState({ startRigthFlat: this.state.startRigthFlat - 1 })
        }
    }
    public minusEndRigthFlat = () => {
        if (this.state.endRigthFlat > 1 && this.state.endRigthFlat > this.state.startRigthFlat) {
            this.setState({ endRigthFlat: this.state.endRigthFlat - 1 })
        }
    }

    public plusStartRigthFlat = () => {
        if (this.state.endRigthFlat > this.state.startRigthFlat) {
            this.setState({ startRigthFlat: this.state.startRigthFlat + 1 })
        } else {
            this.setState({ startRigthFlat: this.state.startRigthFlat + 1, endRigthFlat: this.state.startRigthFlat + 1 })
        }
    }
    public plusEndRigthFlat = () => {
        this.setState({ endRigthFlat: this.state.endRigthFlat + 1 })
    }

    public get allCount() {
        const { endLeftFlat, endRigthFlat, startLeftFlat, startRigthFlat } = this.state
        return (endLeftFlat - startLeftFlat) + (endRigthFlat - startRigthFlat) + 2
    }

    public onAddProduct = () => {
        const { addProduct } = this.props.busket
        const { startLeftFlat, endLeftFlat, startRigthFlat, endRigthFlat } = this.state
        const descriptions = `влево c ${startLeftFlat} по ${endLeftFlat} вправо ${startRigthFlat} по ${endRigthFlat}`
         addProduct(this.props.item, 1, this.state.startLeftFlat, this.state.endRigthFlat, descriptions)
         this.props.onClose()
    }


    render() {
        const { startLeftFlat, endLeftFlat, startRigthFlat, endRigthFlat } = this.state

        return <Dialog onClose={this.props.onClose}>
            <div className="floors_number_container">
                <img className="dialogClose" onClick={this.props.onClose} src="/local/templates/sign_plus/images/close.svg" alt="" />
                <div className="dialogContaine__inner">
                    <div className="title">
                        {this.props.item.name}
                    </div>
                    <div className="top_block">
                        <img className={this.props.item.type === 39 ? "big_picture" : "small_picture"} src={this.props.item.img} />
                        <div className="title">Квартиры</div>
                        <div className="numbers left">
                            <div className="left_number">Налево</div>
                            <div className="with">c</div>
                            <div className='swither_container'>
                                <div className="minus" onClick={this.minusStartLeftFlat}>-</div>
                                <div className="count">{startLeftFlat}</div>
                                <div className="plus" onClick={this.plusStartLeftFlat}>+</div>
                            </div>
                            <div className="on">по</div> <div className="minus" onClick={this.minusEndLeftFlat}>-</div>
                            <div className="count">{endLeftFlat}</div>
                            <div className="plus" onClick={this.plusEndLeftFlat}>+</div>
                        </div>
                        <div className="numbers rigth">
                            <div className="rigth_number">Направо</div>
                            <div className="with">c</div>
                            <div className='swither_container'>
                                <div className="minus" onClick={this.minusStartRigthFlat}>-</div>
                                <div className="count">{startRigthFlat}</div>
                                <div className="plus" onClick={this.plusStartRigthFlat}>+</div>
                            </div>
                            <div className="on">по</div> <div className="minus" onClick={this.minusEndRigthFlat}>-</div>
                            <div className="count">{endRigthFlat}</div>
                            <div className="plus" onClick={this.plusEndRigthFlat}>+</div>
                        </div>
                    </div>
                    <div className="bottom_block">
                        <div className="price">{this.props.item.price} руб/шт</div>
                        <div className="count">{1} шт</div>
                        <div className="allPrice">{this.props.item.price} руб</div>
                    </div>
                    <div className="inBusker" onClick={this.onAddProduct}>В корзину</div>
                </div>

            </div>
        </Dialog>
    }
}

const storesToProps = ({ store }: IStoresMap, _nextProps: any) => ({
    busket: store.BusketStore
})

export default connector(storesToProps)(FlatsNumbersPopUp)
